module.exports = __webpack_public_path__ + "static/korobeinikiEndingArranged-902adb81e2469c10efce6e0f36d9dc69.mp3";